//展示管理
import http from '../jslibs/axios/http';

// 课程订单列表
export const getCourseOrderList = data => http.get('/cms/CourseOrder', data);
// 课程订单详情
export const getCourseOrderDetail = data => http.get('/cms/CourseOrder/' + data.uuid);


// 培训订单列表
export const getTrainOrderList = data => http.get('/cms/TrainOrder', data);
// 培训订单详情
export const getTrainOrderDetail = data => http.get('/cms/TrainOrder/' + data.uuid);
// 取消培训订单
export const deleteTrainOrderDetail = data => http.delete('/cms/TrainOrder/' + data.uuid);


// 会员订单列表
export const getMemberOrderList = data => http.get('/cms/MemberOrder', data);
// 会员订单详情
export const getMemberOrderDetail = data => http.get('/cms/MemberOrder/' + data.uuid);
